const sizes = {
    xs: {
        dialog: {
            maxW: 60,
        },
    },
}

export const Drawer = { sizes }
